"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mail = void 0;
var mail = {
  "viewBox": "0 0 64 64",
  "children": [{
    "name": "g",
    "attribs": {
      "id": "MAIL_1_",
      "enable-background": "new    "
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "MAIL"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "MAIL"
        },
        "children": [{
          "name": "g",
          "attribs": {},
          "children": [{
            "name": "g",
            "attribs": {},
            "children": [{
              "name": "path",
              "attribs": {
                "d": "M63.002,10.78C62.471,10.3,61.773,10,61,10H3c-0.773,0-1.47,0.3-2.002,0.78L32,35L63.002,10.78z M0.894,10.866\r\n\t\t\t\tC0.343,11.41,0,12.165,0,13v38c0,0.789,0.311,1.501,0.809,2.037l19.569-23.296L0.894,10.866z M32,41l-8.136-7.881L0.943,53.175\r\n\t\t\t\tC1.481,53.684,2.202,54,3,54h58c0.798,0,1.52-0.316,2.057-0.825l-22.92-20.056L32,41z M63.105,10.866L43.622,29.741\r\n\t\t\t\tl19.569,23.296C63.689,52.502,64,51.789,64,51V13C64,12.165,63.657,11.41,63.105,10.866z"
              },
              "children": [{
                "name": "path",
                "attribs": {
                  "d": "M63.002,10.78C62.471,10.3,61.773,10,61,10H3c-0.773,0-1.47,0.3-2.002,0.78L32,35L63.002,10.78z M0.894,10.866\r\n\t\t\t\tC0.343,11.41,0,12.165,0,13v38c0,0.789,0.311,1.501,0.809,2.037l19.569-23.296L0.894,10.866z M32,41l-8.136-7.881L0.943,53.175\r\n\t\t\t\tC1.481,53.684,2.202,54,3,54h58c0.798,0,1.52-0.316,2.057-0.825l-22.92-20.056L32,41z M63.105,10.866L43.622,29.741\r\n\t\t\t\tl19.569,23.296C63.689,52.502,64,51.789,64,51V13C64,12.165,63.657,11.41,63.105,10.866z"
                },
                "children": []
              }]
            }]
          }]
        }]
      }]
    }]
  }]
};
exports.mail = mail;